import { createSimpleWrapper } from "../tag/createSimpleWrapper";

export const ListItem = createSimpleWrapper("div", "d-flex");
